module.exports = __webpack_public_path__ + "static/asien-5785d27b14582d1bb2a5571380365634.svg";